import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Http, Headers } from '@angular/http';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'app-state',
  templateUrl: './state.page.html',
  styleUrls: ['./state.page.scss'],
})
export class StatePage implements OnInit {
  token:any;
  actname:any;
  actresult:any;
  url:any;

  //client_id:any = "l7xx887c5a617205417f9088c4d4a83a9cc9"
  //client_secret = "ee1e2ae7a98445a09088c30b9f278e7f";
  constructor(public http:Http,private route: ActivatedRoute, public router: Router,private sanitizer: DomSanitizer) {
    //this.token = this.route.snapshot.queryParamMap.get('token');
    //this.initpoli();
   }
//POLiFailure?token=71qC0loQLSijA0hByxT6Tp4vKhHLToGj&cancellation=False
  ngOnInit() {
  }

  userprof(){
    var apiUrl:any = "https://testapi.open-platform.or.kr/oauth/2.0/authorize2";
    apiUrl = apiUrl+ '?response_type=code&client_id=l7xxb2965189558842feaba7ec1e46a4ab00&redirect_uri=http://localhost:8100/state&scope=transfer&client_info=2010001651&auth_type=0&bg_color=white&txt_color=#555&btn1_color=#5a82e1&btn2_color=#5a82e1'
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(apiUrl);
    //window.open(apiUrl, "_self"); 
    //this.router.navigateByUrl(apiUrl)
    /*
    this.actname = "사용자 인증";
    this.actresult = "....시도중....";
    var apiUrl:any = "https://stark-sands-51177.herokuapp.com/https://testapi.open-platform.or.kr/oauth/2.0/authorize2";
    apiUrl = apiUrl+ '?response_type=code&client_id=l7xxb2965189558842feaba7ec1e46a4ab00&redirect_uri=http://localhost:8100/state&scope=transfer&client_info=2010001651&auth_type=0&bg_color=white&txt_color=black&btn1_color=blue&btn2_color=gray'
		
//l7xxb2965189558842feaba7ec1e46a4ab00
//fbcff3b9aa114e43954b056ca363178b
    new Promise((resolve, reject)=>{
        //let headers = new Headers();
        //headers.append("Content-Type", "application/x-www-form-urlencoded;charset=UTF-8");
        this.http.get(apiUrl)
            .subscribe(res => {
              this.actresult = '사용자 인증 들어옴\n';
              console.log(res);
              //this.router.navigate(['/tfnudge', {url:res['headers'].toJSON()['x-final-url']}]);
              //this.url = this.sanitizer.bypassSecurityTrustHtml(res['headers'].toJSON()['x-final-url']);
              this.url = this.sanitizer.bypassSecurityTrustHtml(res['_body']);
              //console.log(res[0]);
              //console.log(res['_body'].json());
              //console.log(res['header']);
              //console.log(res['body']);
              
              //(['/payment', {url:res.NavigateURL}]);
              //this.url = res.url;
            resolve(res);
            }, (err) => {
            console.log(err);
            reject(err);
            });
        })*/
  }

  /* 인증토큰 포스트 성공
  userprof(){
    this.actname = "사용자 인증";
    this.actresult = "....시도중....";
    var apiUrl:any = "https://stark-sands-51177.herokuapp.com/https://testapi.open-platform.or.kr/oauth/2.0/token";
    var data: {
		  client_id: 'l7xxb2965189558842feaba7ec1e46a4ab00', //'l7xx887c5a617205417f9088c4d4a83a9cc9',//
			client_secret:  'fbcff3b9aa114e43954b056ca363178b',//'ee1e2ae7a98445a09088c30b9f278e7f',//
			grant_type: 'client_credentials',
			scope: 'oob'
		}
//l7xxb2965189558842feaba7ec1e46a4ab00
//fbcff3b9aa114e43954b056ca363178b
    new Promise((resolve, reject)=>{
    let headers = new Headers();
        headers.append("Content-Type", "application/x-www-form-urlencoded;charset=UTF-8");
        this.http.post(apiUrl, 
          'client_id=l7xx887c5a617205417f9088c4d4a83a9cc9&client_secret=ee1e2ae7a98445a09088c30b9f278e7f&grant_type=client_credentials&scope=oob'
          , {headers: headers})
            .subscribe(res => {
              this.actresult = '사용자 인증 성공\n';
              this.actresult += JSON.stringify(res);
              console.log(res.access_token);
              this.token = res.access_token;
            resolve(res);
            }, (err) => {
            console.log(err);
            reject(err);
            });
        })
  }*/
    userinfoaccess(){
    this.actname = "사용자 정보조회";
    this.actresult = "....시도중....";
    var apiUrl = "https://stark-sands-51177.herokuapp.com/https://testapi.open-platform.or.kr/user/me?user_seq_no=0100000001";
    new Promise((resolve, reject)=>{
    let headers = new Headers();
        headers.append("Content-Type", "application/x-www-form-urlencoded;charset=UTF-8");
        headers.append("Authorization", "Bearer " + this.token);

        this.http.get(apiUrl
          , {headers: headers})
            .subscribe(res => {
              this.actresult = '정보조회 성공\n';
              this.actresult += JSON.stringify(res);
              console.log(res);
            resolve(res);
            }, (err) => {
            console.log(err);
            reject(err);
            });
        })
  }
    accountaccess(){
    this.actname = "계등록 좌조회";
    var apiUrl = "https://stark-sands-51177.herokuapp.com/https://testapi.open-platform.or.kr/oauth/2.0/authorize_account";
    var data: {
		  client_id: 'l7xx887c5a617205417f9088c4d4a83a9cc9', //'l7xxb2965189558842feaba7ec1e46a4ab00',
			client_secret: 'ee1e2ae7a98445a09088c30b9f278e7f',// 'fbcff3b9aa114e43954b056ca363178b',
			grant_type: 'client_credentials',
			scope: 'oob'
		}
//l7xxb2965189558842feaba7ec1e46a4ab00
//fbcff3b9aa114e43954b056ca363178b
    new Promise((resolve, reject)=>{
    let headers = new Headers();
        headers.append("Content-Type", "application/x-www-form-urlencoded;charset=UTF-8");
        this.http.post(apiUrl, 
          'client_id=l7xx887c5a617205417f9088c4d4a83a9cc9&client_secret=ee1e2ae7a98445a09088c30b9f278e7f&grant_type=client_credentials&scope=oob'
          , {headers: headers})
            .subscribe(res => {
              console.log('성공');
              console.log(res['access_token']);
            resolve(res);
            }, (err) => {
            console.log(err);
            reject(err);
            });
        })
  }
      accountbalance(){
    var apiUrl = "https://stark-sands-51177.herokuapp.com/https://testapi.open-platform.or.kr//user/me";
    var data: {
		  client_id: 'l7xx887c5a617205417f9088c4d4a83a9cc9', //'l7xxb2965189558842feaba7ec1e46a4ab00',
			client_secret: 'ee1e2ae7a98445a09088c30b9f278e7f',// 'fbcff3b9aa114e43954b056ca363178b',
			grant_type: 'client_credentials',
			scope: 'oob'
		}
//l7xxb2965189558842feaba7ec1e46a4ab00
//fbcff3b9aa114e43954b056ca363178b
    new Promise((resolve, reject)=>{
    let headers = new Headers();
        headers.append("Content-Type", "application/x-www-form-urlencoded;charset=UTF-8");
        this.http.post(apiUrl, 
          'client_id=l7xx887c5a617205417f9088c4d4a83a9cc9&client_secret=ee1e2ae7a98445a09088c30b9f278e7f&grant_type=client_credentials&scope=oob'
          , {headers: headers})
            .subscribe(res => {
              console.log('성공');
              console.log(res['access_token']);
            resolve(res);
            }, (err) => {
            console.log(err);
            reject(err);
            });
        })
  }
      accounttrans(){
    var apiUrl = "https://stark-sands-51177.herokuapp.com/https://testapi.open-platform.or.kr/account/transaction_list";
    var data: {
		  client_id: 'l7xx887c5a617205417f9088c4d4a83a9cc9', //'l7xxb2965189558842feaba7ec1e46a4ab00',
			client_secret: 'ee1e2ae7a98445a09088c30b9f278e7f',// 'fbcff3b9aa114e43954b056ca363178b',
			grant_type: 'client_credentials',
			scope: 'oob'
    }
    /*
fintech_use_num
inquiry_type
from_date
to_date
sort_order
page_index
tran_dtime*/
//befor_inquiry_trace_info
//list_tran_seqno

    new Promise((resolve, reject)=>{
    let headers = new Headers();
        headers.append("Content-Type", "application/x-www-form-urlencoded;charset=UTF-8");
        this.http.post(apiUrl, 
          'client_id=l7xx887c5a617205417f9088c4d4a83a9cc9&client_secret=ee1e2ae7a98445a09088c30b9f278e7f&grant_type=client_credentials&scope=oob'
          , {headers: headers})
            .subscribe(res => {
              console.log('성공');
              console.log(res['access_token']);
            resolve(res);
            }, (err) => {
            console.log(err);
            reject(err);
            });
        })
  }

}
